import { CreateStepperState } from "./types";

export const initState: CreateStepperState = {
  currentTab: 0,
  subStep: 0,
};
